import { render, staticRenderFns } from "./AuthModalSignUpComponent.html?vue&type=template&id=751cf270&"
import script from "./AuthModalSignUpComponent.js?vue&type=script&lang=js&"
export * from "./AuthModalSignUpComponent.js?vue&type=script&lang=js&"
import style0 from "./AuthModalSignUpComponent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports